// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Loading_backdrop__3mOyS","main":"Loading_main__2wtAk","loader":"Loading_loader__2Olgp","spinner":"Loading_spinner__3ubDR"};